// extracted by mini-css-extract-plugin
export default {"container":"style_container__FVvWm","box":"style_box__SCcXk","boxContent":"style_boxContent__SQ4cy","boxHeader":"style_boxHeader__p5SCM"};